export default "__VITE_PUBLIC_ASSET__aa83f267__"